import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonProps, Tooltip } from "@ui";
import { cva, VariantProps } from "class-variance-authority";
import React, { HTMLAttributes } from "react";

interface Props extends Omit<ButtonProps, "icon"> {
    tooltip?: React.ReactNode;
    tooltipProps?: any;
    icon?: IconDefinition;
}

const TableActionButton = ({ tooltip, tooltipProps: _tooltipProps, icon, ...props }: Props) => {
    const { ...tooltipProps } = _tooltipProps || {};
    return (
        <Tooltip flat withArrow placement="top" tooltip={tooltip} {...tooltipProps}>
            <Button size="sm" flat aria-label={typeof tooltip === 'string' ? tooltip : undefined} {...props}>
                <FontAwesomeIcon icon={icon} />
            </Button>
        </Tooltip>
    );
};

const buttonGridClasses = cva("tw-flex tw-flex-wrap tw-justify-end tw-gap-3", {
    variants: {
        justify: {
            "flex-end": "tw-justify-end",
            end: "tw-justify-end",
        },
    },
});

const ButtonGrid = ({
    className,
    justify,
    ...props
}: HTMLAttributes<HTMLDivElement> & VariantProps<typeof buttonGridClasses>) => (
    <div className={buttonGridClasses({ className, justify })} {...props} />
);

TableActionButton.Container = ButtonGrid;

export default TableActionButton;
